var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStatus01 = function SvgIconStatus01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_status-01_svg2__a",
    x1: 8.86,
    x2: 91.02,
    y1: 12.8,
    y2: 83.95,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_status-01_svg2__a",
    id: "icon_status-01_svg2__b",
    x1: 20.28,
    x2: 102.45,
    y1: -0.4,
    y2: 70.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_status-01_svg2__a",
    id: "icon_status-01_svg2__c",
    x1: -6.1,
    x2: 76.05,
    y1: 30.08,
    y2: 101.23
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 60c-9.19 0-16.66 7.47-16.66 16.66s7.47 16.66 16.66 16.66 16.66-7.47 16.66-16.66S32.52 60 23.33 60m0 30C15.98 90 10 84.02 10 76.67s5.98-13.33 13.33-13.33 13.33 5.98 13.33 13.33S30.68 90 23.33 90",
    style: {
      fill: "url(#icon_status-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.66 53.33H23.33C10.46 53.33 0 63.79 0 76.66s10.46 23.33 23.33 23.33h53.33c12.86 0 23.33-10.46 23.33-23.33S89.53 53.33 76.66 53.33m0 43.33H23.33c-11.03 0-20-8.97-20-20s8.97-20 20-20h53.33c11.03 0 20 8.97 20 20s-8.97 20-20 20",
    style: {
      fill: "url(#icon_status-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 46.67h53.33c12.86 0 23.33-10.46 23.33-23.33S89.53 0 76.66 0H23.33C10.46 0 0 10.47 0 23.34s10.46 23.33 23.33 23.33m53.33-40c9.19 0 16.66 7.47 16.66 16.66s-7.47 16.66-16.66 16.66S60 32.52 60 23.33 67.47 6.67 76.66 6.67",
    style: {
      fill: "url(#icon_status-01_svg2__c)"
    }
  }));
};
export default SvgIconStatus01;